import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { AccountModule } from '@blade-sxp/account/store/account';
import { EType } from '@blade-sxp/account/interfaces/account';
import { handleError } from '@blade/common/utils/handle-error';
import { getAKSK, updateSK } from '@blade-sxp/account/api/aksk';
import { getParamTime, updateParamTime } from '@blade-sxp/account/api/params-setting';
import HeatMap from '@blade-sxp/account/pages/params-management/components/heat-map.vue';
import CloseTime from '@blade-sxp/account/pages/params-management/components/close-time.vue';
import * as _ from 'lodash';
let default_1 = class extends Vue {
    closeTimer = '';
    input = '';
    radio = EType.MAX_CAPACITY;
    messageBox;
    num;
    countDownSecs = 5;
    dialogVisible = false;
    fullSkDialogVisible = false;
    updSkDialogVisible = false;
    debouncedFun;
    ruleForm = {
        input: '',
    };
    accessKey = '';
    secretAccessKey = '';
    pwd = '';
    fullSK = '';
    showFullSK = false;
    get Text() {
        const res = this.countDownSecs >= 0 ? `${this.countDownSecs} s` : this.$t('common.confirm').toString();
        return res;
    }
    get parameterRules() {
        return {
            rule1: [
                {
                    required: true,
                    message: this.$t('paramManagement.rule1').toString(),
                    trigger: ['blur', 'change'],
                    validator: (rule, value, callback) => {
                        if (this.radio === EType.CUSTOM_PERIOD &&
                            !(this.isNumeric(this.input) && Number(this.input) > 0 && Number(this.input) <= 9999)) {
                            return callback(new Error(this.$t('paramManagement.rule1').toString()));
                        }
                        callback();
                    },
                },
            ],
        };
    }
    mounted() {
        this.getAKSK();
        this.getTenant();
        this.debouncedFun = _.debounce(this.getDisabled, 500);
        this.$refs['ruleForm'].clearValidate();
        this.getParamTime();
    }
    updateParamTime() {
        // const Id = AccountModule?.accountInfo?.tenantId as string;
        const param = {
            zoneResetTime: this.closeTimer,
        };
        updateParamTime(param)
            .then((res) => {
            const msg = this.$t('updateTime').toString();
            this.$message({ type: 'success', message: msg });
        })
            .catch((er) => { });
    }
    getParamTime() {
        // const Id = AccountModule?.accountInfo?.tenantId as string;
        getParamTime()
            .then((res) => {
            if (res.status === 200 && res.data) {
                this.closeTimer = res?.data?.data?.zoneResetTime ?? '';
            }
        })
            .catch((er) => { });
    }
    async getTenant() {
        try {
            const res = (await AccountModule.getTenantById(this.accessKey));
            const params = res.data;
            this.input = params.storeNum;
            this.radio = params.type;
        }
        catch (e) {
            handleError(e);
        }
    }
    async getAKSK() {
        try {
            const res = await getAKSK();
            const params = res.data.data;
            this.accessKey = params.accessKey;
            this.fullSK = params.secret;
            this.secretAccessKey = this.fullSK
                .substr(0, 4)
                .concat(new Array(this.fullSK.length - 8).fill('*').join(''))
                .concat(this.fullSK.substr(-4));
        }
        catch (e) {
            handleError(e);
        }
    }
    async querySK() {
        try {
            const res = (await AccountModule.doubleCheck(this.pwd));
            const param = res.data;
            if (param) {
                this.showFullSK = true;
            }
        }
        catch (e) {
            handleError(e);
        }
    }
    async updateSK() {
        try {
            const res = (await AccountModule.doubleCheck(this.pwd));
            const param = res.data;
            if (param) {
                await updateSK({ akId: this.accessKey });
                this.pwd = '';
                this.getAKSK();
                this.updSkDialogVisible = false;
                this.$message.success(`${this.$t('common.success')}`);
            }
        }
        catch (e) {
            handleError(e);
        }
    }
    handleCancel() {
        console.log('cancel');
        this.dialogVisible = false;
        this.getTenant();
        clearInterval(this.num);
    }
    async handleConfirm() {
        console.log('submit');
        this.dialogVisible = false;
        const formData = { storeNum: this.radio === EType.CUSTOM_PERIOD ? this.input : '', tenantId: '', type: this.radio };
        try {
            await AccountModule.updateTenant(formData);
        }
        catch (e) {
            handleError(e);
        }
    }
    handleChange() {
        if (this.radio === EType.CUSTOM_PERIOD) {
            return;
        }
        this.getDisabled();
        this.$refs['ruleForm'].clearValidate();
        this.input = '0';
    }
    getDisabled() {
        this.countDownSecs = 5;
        this.num = setInterval(this.timer, 1000);
        this.dialogVisible = true;
    }
    timer() {
        console.log('timer:', this.countDownSecs);
        this.countDownSecs--;
        if (this.countDownSecs < 0) {
            clearInterval(this.num);
        }
    }
    handleClose() {
        console.log('close');
        this.dialogVisible = false;
        this.getTenant();
        clearInterval(this.num);
    }
    handleInput() {
        console.log('input:', this.isNumeric(this.input) && Number(this.input) > 0);
        if (!(this.isNumeric(this.input) && Number(this.input) > 0 && Number(this.input) <= 9999)) {
            this.debouncedFun.cancel();
            return;
        }
        this.debouncedFun();
    }
    isNumeric(value) {
        return /^-?\d+$/.test(value);
    }
};
default_1 = __decorate([
    Component({
        name: 'AccountList',
        components: { HeatMap, CloseTime },
        i18n: {
            messages: {
                'en-us': {
                    updateTime: 'Time modified successfully',
                    timeSelection: 'Time selection',
                    closingTime: 'Closing time',
                    picTime: 'Image storage duration',
                    picType: 'Image type includes: Monitor face images, Alert face images, Face snapshots, Pass images, Pass snapshots',
                    mode1: 'Not save(private mode)',
                    mode2: 'Customized duration',
                    mode3: 'Max allowed limit',
                    day: 'Day',
                    submit: 'Submit',
                    cancel: 'Cancel',
                    pic1: 'Change storage duration may cause data loss, please take note.',
                    permission: ' Access Permission',
                    viewFullSK: 'View Full SK',
                    updTip: 'After the update, the original AK/SK will be invalid',
                    updTip2: 'After updating AK/SK, the original AK/SK will be invalid, please proceed with caution!',
                    beforeView: 'Before viewing the full SK, please enter your login password:',
                    enterPwd: 'Please enter your login password',
                    fullSK: 'The complete Secret Access Key:',
                    beforeUpd: 'Before updating AK/SK, please enter your login password:',
                },
                zh: {
                    updateTime: '修改时间成功',
                    timeSelection: '选择时间',
                    closingTime: '营业结束时间',
                    picTime: '图片存储时长',
                    picType: '图片类型包含：人脸布控底图，人脸布控告警图，人脸抓拍图，通行底图，通行抓拍图',
                    mode1: '不存储（无痕模式)',
                    mode2: '自定义时间存储',
                    mode3: '按最大容量存储',
                    day: '天',
                    submit: '确认',
                    cancel: '取消',
                    pic1: '变更存储时长可能会导致数据丢失，请谨慎操作!',
                    permission: '访问权限',
                    viewFullSK: '查看完整SK',
                    updTip: '更新后，原有AK/SK将失效',
                    updTip2: '更新AK/SK后，原有AK/SK将失效，请谨慎操作!',
                    beforeView: '查看完整SK之前，请输入你的登陆密码：',
                    enterPwd: '请输入你的登陆密码',
                    fullSK: '完整的Secret Access Key：',
                    beforeUpd: '更新AK/SK之前，请输入你的登陆密码：',
                },
            },
        },
    })
], default_1);
export default default_1;
